module.exports = __webpack_public_path__ + "img/spacing-width-02.4c7025e2.svg";